import styled from 'styled-components';
import { m, p } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';
import Grid from 'styled-components-grid';

export const StyledCover = styled(Grid)`
  width: 100%;
  ${theme.gradients.linearSoftMakrBlueTwoFadedBlueLTR};
`;

export const StyledFormWrapper = styled(Grid.Unit)``;

export const StyledTimelineCover = styled.div``;

export const StyledTimelineWrapper = styled.div`
  // ${p(1)};
  display: flex;
  flex-direction: row;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  ${breakpoint('mobile', 'tablet')`
  ${p(0)};
  align-items: flex-start;
  `};
`;

export const StyledUnit = styled.div`
  ${m(1)};
  ${p(1)};
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${breakpoint('mobile', 'tablet')`
  ${m(0)};
  ${p(0)};
  font-size: 10px;
  align-items:center;
  `};
`;

export const StyledHrLine = styled.div`
  flex: 1;
  border-bottom: 1px solid gray;
  ${breakpoint('tablet', 'desktop')`
  width: calc(100% - 20px);
  `};
  ${breakpoint('mobile', 'tablet')`
   width:100%;
   top: 18px;
   position: relative;
   
  `};
`;

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  font-weight: 700;
  // padding-left: 16px;
  // min-width: 120px;
  // text-align: center;
  color: ${props =>
    (props.paymentScreen || props.packageFormScreen || props.paymentSuccessfull
      ? theme.colors.logoBlue
      : theme.colors.mediumGray)};
  ${breakpoint('mobile', 'tablet')`
    // text-align: right;
    line-height: 1.2;
    font-size: 14px;
  `};
`;

export const StyledDisabledTimelineIcon = styled.div`
  width: 30px;
  height: 25px;
  ${m(1)};
  display: flex;
  flex: 1;
  aspect-ratio: 1/1;
  position: relative;
  background-color: ${props =>
    (props.paymentScreen || props.packageFormScreen || props.paymentSuccessfull
      ? theme.colors.logoBlue
      : theme.colors.lightGray)};
  border-radius: 50px;
  ${breakpoint('mobile', 'tablet')`
  width: 24px;
  height: 20px;
  `};
`;

export const StyledTimelineIconWrapper = styled.div`
  width: 100%;
  ${props =>
    (props.paymentSuccessfull
      ? ' display: block'
      : (props.packageFormScreen || props.paymentScreen) && ' display: none')}
  // display: ${props => (props.packageFormScreen || props.paymentScreen ? 'none' : '')};
`;

export const StyledGridHeading = styled.div`
      display: flex;
      justify-content: space-between;
      padding-left: 8px;
      padding-right: 8px;
`;

export const TextWrapper = styled.div`
      width: 140px;
      display: flex;
      justify-content: flex-end;
`;

export const Text = styled.div`
      #successfulPayment{
        text-align: right;
      }
`;
